<template>
    <div class="_content">
        <div class="tabs">
            <van-tabs v-model="active" color="rgb(25,137,250)">

                <van-tab class="change_shopinfo_tab" title="基本信息">

                    <van-cell-group >
                        <van-field input-align="right" is-link  v-model="StoreInfo_val1" label="店招名称" placeholder="请输入" />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field input-align="right" is-link  v-model="StoreInfo_val2" label="门店负责人" placeholder="请输入" />
                    </van-cell-group>
                    <!-- 负责人类型 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="负责人类型"
                            :value="StoreInfo_val3"
                            placeholder="请选择"
                            @click="StoreInfo_Picker1 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="StoreInfo_Picker1" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择负责人类型" 
                            :columns="StoreInfo_columns1"   
                            @cancel="StoreInfo_Picker1 = false"
                            @confirm="StoreInfo_onConfirm1"
                            />
                        </van-popup>
                    </van-cell-group>

                    <van-cell-group>
                        <van-field input-align="right" is-link  v-model="StoreInfo_val4" label="负责人电话" placeholder="请输入" />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field input-align="right" is-link  v-model="StoreInfo_val5" label="门店电话" placeholder="请输入" />
                    </van-cell-group>

                    <!-- 店铺区域 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="店铺区域"
                            :value="StoreInfo_val6"
                            placeholder="请选择"
                            @click="StoreInfo_Picker2 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="StoreInfo_Picker2" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择地址" 
                            :columns=" StoreInfo_columns2"   
                            @cancel="StoreInfo_Picker = false"
                            @confirm="StoreInfo_onConfirm2"
                            />
                        </van-popup>
                    </van-cell-group>

                    <van-cell-group>
                        <van-field input-align="right" is-link  v-model="StoreInfo_val7" label="门店地址" placeholder="请输入" />
                    </van-cell-group>
                    
                    <van-button @click="handleClick1(tabList1[0])" class="shop_info_btn" size="large" color="rgb(25,137,250)" type="info" >保存</van-button>
                </van-tab>

                <van-tab class="change_shopinfo_tab" title="店铺信息">
                    <!-- 门店类型 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="门店类型"
                            :value="Shopinfo_val1"
                            placeholder="请选择"
                            @click="Shopinfo_Picker1 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker1" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择门店类型" 
                            :columns="Shopinfo_columns1"   
                            @cancel="Shopinfo_1 = false"
                            @confirm="Shopinfo_onConfirm1"
                            />
                        </van-popup>
                    </van-cell-group>
                    <!-- 主营服务 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="主营服务"
                            :value="Shopinfo_val2"
                            placeholder="请选择"
                            @click="Shopinfo_Picker2 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker2" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择主营服务" 
                            :columns="Shopinfo_columns2"   
                            @cancel="Shopinfo_2 = false"
                            @confirm="Shopinfo_onConfirm2"
                            />
                        </van-popup>
                    </van-cell-group>
                    <!-- 营业项目复选框 -->
                    <van-cell-group class="shop_checkbox_group">
                        <!-- <van-cell title="营业项目" is-link value="请选择" /> -->
                        <span>营业项目</span>
                        <van-checkbox-group class="checkbox_group" v-model="result" direction="horizontal" ref="checkboxGroup">
                            <van-checkbox name="全选" v-model="Shopinfo_checked1" @click="checkAll()" shape="square">全选</van-checkbox>
                            <van-checkbox name="洗车" shape="square">洗车</van-checkbox>
                            <van-checkbox name="美容" shape="square">美容</van-checkbox>
                            <van-checkbox name="装潢" shape="square">装潢</van-checkbox>
                            <van-checkbox name="保养" shape="square">保养</van-checkbox>
                            <van-checkbox name="油漆" shape="square">油漆</van-checkbox>
                            <van-checkbox name="维修" shape="square">维修</van-checkbox>
                            <van-checkbox name="救援" shape="square">救援</van-checkbox>
                            <van-checkbox name="年检" shape="square">年检</van-checkbox>
                            <van-checkbox name="保险" shape="square">保险</van-checkbox>
                            <van-checkbox name="理赔" shape="square">理赔</van-checkbox>
                            <van-checkbox name="轮胎" shape="square">轮胎</van-checkbox>
                            <van-checkbox name="安全检测" shape="square">安全检测</van-checkbox>
                            <van-checkbox name="四轮定位" shape="square">四轮定位</van-checkbox>
                            <van-checkbox name="动平衡" shape="square">动平衡</van-checkbox>
                        </van-checkbox-group>
                    </van-cell-group>
                    <!-- 营业面积 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="营业面积"
                            :value="Shopinfo_val3"
                            placeholder="请选择"
                            @click="Shopinfo_Picker3 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker3" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择营业面积" 
                            :columns="Shopinfo_columns3"   
                            @cancel="Shopinfo_3 = false"
                            @confirm="Shopinfo_onConfirm3"
                            />
                        </van-popup>
                    </van-cell-group>                       
                    <!-- 洗车工位 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="洗车工位"
                            :value="Shopinfo_val4"
                            placeholder="请选择"
                            @click="Shopinfo_Picker4 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker4" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择洗车工位" 
                            :columns="Shopinfo_columns4"   
                            @cancel="Shopinfo_4 = false"
                            @confirm="Shopinfo_onConfirm4"
                            />
                        </van-popup>
                    </van-cell-group>    
                    <!-- 美容工位 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="美容工位"
                            :value="Shopinfo_val5"
                            placeholder="请选择"
                            @click="Shopinfo_Picker5 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker5" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择美容工位" 
                            :columns="Shopinfo_columns5"   
                            @cancel="Shopinfo_5 = false"
                            @confirm="Shopinfo_onConfirm5"
                            />
                        </van-popup>
                    </van-cell-group>   
                    <!-- 维保工位 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="维保工位"
                            :value="Shopinfo_val6"
                            placeholder="请选择"
                            @click="Shopinfo_Picker6 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker6" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择维保工位" 
                            :columns="Shopinfo_columns6"   
                            @cancel="Shopinfo_6 = false"
                            @confirm="Shopinfo_onConfirm6"
                            />
                        </van-popup>
                    </van-cell-group>   
                    <!-- 烤漆房数 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="烤漆房数"
                            :value="Shopinfo_val7"
                            placeholder="请选择"
                            @click="Shopinfo_Picker7 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="Shopinfo_Picker7" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="选择烤漆房数" 
                            :columns="Shopinfo_columns7"   
                            @cancel="Shopinfo_7 = false"
                            @confirm="Shopinfo_onConfirm7"
                            />
                        </van-popup>
                    </van-cell-group>   
                    <!-- 独立休息区 -->
                    <van-cell-group> 
                        <van-field name="radio" label="独立休息区" input-align="right">
                            <template #input>
                                <van-radio-group v-model="Shopinfo_radio" direction="horizontal">
                                <van-radio name="0">有</van-radio>
                                <van-radio name="1">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                    </van-cell-group> 
                    
                    <van-button @click="handleClick2(tabList1[0])" size="large" class="shop_info_btn" color="rgb(25,137,250)" type="info">保存</van-button>
                </van-tab>

                <van-tab class="change_shopinfo_tab" title="企业信息">
                <!-- 营业执照 -->
                        <van-field name="radio" label="营业执照" input-align="right">
                            <template #input>
                                <van-radio-group v-model="CompanyInfo_radio" direction="horizontal">
                                    <van-radio name="0">有</van-radio>
                                    <van-radio name="1">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-cell-group>
                            <van-field input-align="right" is-link  v-model="CompanyInfo_val1" label="企业法人" placeholder="请输入姓名" />
                        </van-cell-group>
                        <van-cell-group>
                            <van-field input-align="right" is-link type="digit" v-model="CompanyInfo_val2" label="法人手机" placeholder="请输入" />
                        </van-cell-group>
                        <van-cell-group>
                            <van-field input-align="right" is-link type="digit" v-model="CompanyInfo_val3" label="员工人数" placeholder="请输入" />
                        </van-cell-group>

                        <van-button @click="handleClick3(tabList1[0])" size="large" class="shop_info_btn" color="rgb(25,137,250)" type="info">保存</van-button>
                </van-tab>
                
                <van-tab class="change_shopinfo_tab"  title="证照店照">
                    <div class="shop_img">
                        <div class="shop_certificate">
                            <van-uploader upload-text="营业执照" :after-read="afterRead1" :max-count="1"  v-model="StoreImg_fileList1"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>营业执照</span>
                        </div>
                        <div class="shop_certificate">
                            <van-uploader :after-read="afterRead2" :max-count="1"  v-model="StoreImg_fileList2"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>工位图</span>
                        </div>
                        <div class="shop_certificate">
                            <van-uploader :after-read="afterRead3" :max-count="1"  v-model="StoreImg_fileList3"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>工位图</span>
                        </div>
                        <div class="shop_certificate">
                            <van-uploader :after-read="afterRead4" :max-count="1"  v-model="StoreImg_fileList4"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>工位图</span>
                        </div>
                        <div class="shop_certificate">
                            <van-uploader :after-read="afterRead5" :max-count="1"  v-model="StoreImg_fileList5"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>休息区</span>
                        </div>
                        <div class="shop_certificate">
                            <van-uploader :after-read="afterRead6"  v-model="StoreImg_fileList6"  multiple >
                                <img class="shop_uploadimg" src= "~@/imgs/uploadimg.png" alt= "">
                            </van-uploader>
                            <span>其他形象</span>
                        </div>
                    </div>
                    <van-button @click="handleClick4(tabList1[0])" size="large" class="shop_info_btn" color="rgb(25,137,250)" type="info">保存</van-button>
                </van-tab>

            </van-tabs>
        </div>
        <div>

        </div>     
    </div>
</template>
<script>
import config from '@/configs/config'
// import { localStorage } from '@/utils/storage'

export default {
    data() {
        return {
            // 基本信息
            StoreInfo_val1: '',
            StoreInfo_val2: '',
            StoreInfo_val3: '',
            StoreInfo_val4: '',
            StoreInfo_val5: '',
            StoreInfo_val6: '',
            StoreInfo_val7: '',
            StoreInfo_Picker1: false,
            StoreInfo_Picker2: false,
                // 负责人类型
            StoreInfo_columns1: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 区域
            StoreInfo_columns2: [
                {
                text: '浙江',
                    children: [
                        {
                        text: '杭州',
                        children: [{ text: '西湖区' }, { text: '余杭区' }]
                        },
                        {
                        text: '温州',
                        children: [{ text: '鹿城区' }, { text: '瓯海区' }]
                        }
                    ]
                },
                {
                text: '福建',
                    children: [
                        {
                        text: '福州',
                        children: [{ text: '鼓楼区' }, { text: '台江区' }]
                        },
                        {
                        text: '厦门',
                        children: [{ text: '思明区' }, { text: '海沧区' }]
                        }
                    ]
                }
            ],

            // 店铺信息
            Shopinfo_val1: '',
            Shopinfo_val2: '',
            Shopinfo_val3: '',
            Shopinfo_val4: '',
            Shopinfo_val5: '',
            Shopinfo_val6: '',
            Shopinfo_val7: '',
            Shopinfo_Picker1: false,
            Shopinfo_Picker2: false,
            Shopinfo_Picker3: false,
            Shopinfo_Picker4: false,
            Shopinfo_Picker5: false,
            Shopinfo_Picker6: false,
            Shopinfo_Picker7: false,
            Shopinfo_checked1: false,
            result: [],
                // 门店类型
            Shopinfo_columns1: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 主营服务
            Shopinfo_columns2: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 营业面积
            Shopinfo_columns3: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 洗车工位
            Shopinfo_columns4: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 美容工位
            Shopinfo_columns5: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 维保工位
            Shopinfo_columns6: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 烤漆房数
            Shopinfo_columns7: [
                // 类型第一列
                {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
                }
            ],
                // 独立休息去
            Shopinfo_radio: '0',
            // 企业信息
            CompanyInfo_radio: '1',
            CompanyInfo_val1: '',
            CompanyInfo_val2: '',
            CompanyInfo_val3: '',
            // 证照店照
            StoreImg_fileList1: [
                // { url: '' }
                // Uploader 根据文件后缀来判断是否为图片文件
                // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
                // { url: 'https://cloud-image', isImage: true }
            ],
            StoreImg_fileList2: [
            ],
            StoreImg_fileList3: [
            ],
            StoreImg_fileList4: [
            ],
            StoreImg_fileList5: [
            ],
            StoreImg_fileList6: [
            ],
            // 默认tab页
            active: 0,
            title: '1',
            tabList1: [{
                name: '修改门店信息',
                url: '/pages/shopInfo/index'
            }]
        }
    },
    created() {
        this.ShowTab()
    },
    mounted() {
    },
    methods: {
        // ShowTab() {
        //     if (localStorage.get('shopinfo_showtab')) {
        //         this.active = localStorage.get('shopinfo_showtab')
        //         localStorage.remove('shopinfo_showtab')
        //     }
        // },
        handleClick1 (item) {
            // localStorage.set('shopinfo_showtab', this.active)
		    // tuhu.navigateTo({
			//     url: item.url
            // })
            tuhu.fetch(`${config.apis.CHANGE_SHOP_DETAIL}`, {
                method: 'post',
                body: JSON.stringify({
                    'merchantShopDetailInfo': {
                        'cityId': 'string',
                        'cityName': '城市',
                        'districtId': 'string',
                        'districtName': '区',
                        'provinceId': 'string',
                        'provinceName': '省',
                        'shopAddress': this.StoreInfo_val7,
                        'shopLatitude': 0,
                        'shopLongitude': 0,
                        'shopName': this.StoreInfo_val1,
                        'shopPhone': this.StoreInfo_val5,
                        'shopPrincipal': this.StoreInfo_val2,
                        'shopPrincipalPhone': this.StoreInfo_val4,
                        'shopPrincipalType': 0 // this.StoreInfo_val3
                    }
                })
            })
        },
        handleClick2 (item) {
            // localStorage.set('shopinfo_showtab', this.active)
		    // tuhu.navigateTo({
			//     url: item.url
            // })
            // 营业项目
            if (this.result.indexOf('全选') !== -1) {
                this.result.splice(0, 1)
            } else {
                 this.result = this.result
            }
            tuhu.fetch(`${config.apis.CHANGE_SHOP_DETAIL}`, {
                method: 'post',
                body: JSON.stringify({
                    'shopId': 0,
                    'shopStoreInfo': {
                        'businessItems': this.result.join(','), // 营业项目
                        'haveRestArea': parseInt(this.Shopinfo_radio),  // 有无休息区
                        'mainService': this.Shopinfo_val2,  // 主营项目
                        'merchantArea': this.Shopinfo_val3, // 门店面积
                        'shopBank': 'string',
                        'shopType': this.Shopinfo_val1, // 门店类型
                        'stationCondition': 'string'
                    }
                })
            })
        },
        handleClick3 (item) {
            // localStorage.set('shopinfo_showtab', this.active)
		    // tuhu.navigateTo({
			//     url: item.url
            // })
                tuhu.fetch(`${config.apis.CHANGE_SHOP_COMPANYINFO}`, {
                method: 'post',
                body: JSON.stringify({
                    'shopCompanyInfo': {
                        'businessLicense': parseInt(this.CompanyInfo_radio),
                        'enterprisePrincipal': this.CompanyInfo_val1,
                        'enterprisePrincipalPhone': this.CompanyInfo_val2,
                        'staffNum': parseInt(this.CompanyInfo_val3)
                },
                'shopId': 0
                })
            })
        },
        handleClick4 (item) {
            // localStorage.set('shopinfo_showtab', this.active)
		    tuhu.navigateTo({
			    url: item.url
            })
        },
        // 复选框全选
        checkAll() {
            let checked = this.Shopinfo_checked1
            if (checked) {
                this.$refs.checkboxGroup.toggleAll(false)
            } else {
            this.$refs.checkboxGroup.toggleAll(true)
            }
            this.Shopinfo_checked1 = !checked
        },
        // // 反选
        // toggleAll() {
        //     this.$refs.checkboxGroup.toggleAll()
        //     this.Shopinfo_checked1 = !this.Shopinfo_checked1
        // },
        StoreInfo_onConfirm1(value) {
            this.StoreInfo_val3 = value.toString()
            this.StoreInfo_Picker1 = false
        },
        StoreInfo_onConfirm2(value) {
            this.StoreInfo_val6 = value.toString().replace(/,/g, '-')
            this.StoreInfo_Picker2 = false
        },
        Shopinfo_onConfirm1(value) {
            this.Shopinfo_val1 = value.toString()
            this.Shopinfo_Picker1 = false
        },
        Shopinfo_onConfirm2(value) {
            this.Shopinfo_val2 = value.toString()
            this.Shopinfo_Picker2 = false
        },
        Shopinfo_onConfirm3(value) {
            this.Shopinfo_val3 = value.toString()
            this.Shopinfo_Picker3 = false
        },
        Shopinfo_onConfirm4(value) {
            this.Shopinfo_val4 = value.toString()
            this.Shopinfo_Picker4 = false
        },
        Shopinfo_onConfirm5(value) {
            this.Shopinfo_val5 = value.toString()
            this.Shopinfo_Picker5 = false
        },
        Shopinfo_onConfirm6(value) {
            this.Shopinfo_val6 = value.toString()
            this.Shopinfo_Picker6 = false
        },
        Shopinfo_onConfirm7(value) {
            this.Shopinfo_val7 = value.toString()
            this.Shopinfo_Picker7 = false
        },
        // 店证店照 文件上传完毕后会触发after-read回调函数，获取到对应的file对象
        async afterRead1(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        },
         afterRead2(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        },
         afterRead3(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        },
         afterRead4(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        },
         afterRead5(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        },
         afterRead6(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file)
        }
    }
}
</script>
<style lang="less" scoped>
    ._content{
        background: #f4f4f4;
    }
    .shop_img{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: .5rem 1rem 1rem 1rem;
    }
    .shop_uploadimg{
        width: 8rem;
    }
    .shop_certificate{
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
            margin: .2rem 0;
        }
    }
    .change_shopinfo_tab{
        display: flex;
        flex-direction: column;
    }
    .van-uploader__preview{
        margin: 0;
    }
    .van-uploader__preview-image{
        width: 7.5rem;
        margin: .3rem;
    }
    .shop_info_btn{
        .van-button__text{
        color: #fff;
        }
    }
    .shop_checkbox_group{
        display: flex;
        flex-direction: row;
        padding: 1rem 0 1rem .8rem ;
        >span{
            font-size: .7rem;
        }
        .checkbox_group{
            width: 75%;
            padding: 0 0 0 .6rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/changeShopInfo/index.vue